import * as z from "zod/v4";

const MAX_CUSTOM_JS_LENGTH = 51_200;

export const updateCustomJsSettings = {
  name: "updateCustomJsSettings" as const,
  input: z.union([
    // Toggle enabled only — no script or readme needed
    z.object({
      enabled: z.boolean(),
      script: z.undefined(),
      readme: z.undefined(),
    }),
    // Script update — readme is required
    z.object({
      enabled: z.boolean().optional(),
      script: z.string().max(MAX_CUSTOM_JS_LENGTH),
      readme: z.string().min(1).max(MAX_CUSTOM_JS_LENGTH),
    }),
  ]),
  output: z.null(),
};
